module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a ação?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirAcao()
      }
    },
    model: {
      value: (_vm.dialogExclusao),
      callback: function($$v) {
        _vm.dialogExclusao = $$v
      },
      expression: "dialogExclusao"
    }
  }, [_vm._v("\n    Essa ação será excluída após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "white"
    }
  }, [_c('v-toolbar-title', [_vm._v("Barra do administrador")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "text-xs-right"
  }, [_c('c-tooltip-btn', {
    attrs: {
      "icon": "done_outline",
      "color": "green",
      "disabled": _vm.projeto.situacao.item != 16,
      "tooltip": "Aprovar",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando aprovação\" pode ser aprovada"
    },
    on: {
      "click": function($event) {
        return _vm.goAprovarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "not_interested",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 16,
      "tooltip": "Devolver para o coordenador",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando aprovação\" pode ser devolvida para o coordenador"
    },
    on: {
      "click": function($event) {
        return _vm.goDevolverProjeto()
      }
    }
  }), _vm._v(" "), (_vm.projeto.situacao.item === 15 && _vm.projeto.registroTardio === true) ? _c('div', [_c('c-tooltip-btn', {
    attrs: {
      "icon": "post_add",
      "color": "primary",
      "disabled": _vm.projeto.relatorioFinalHabilitado === true,
      "tooltip": "Liberar preenchimento do relatório técnico final",
      "disabled-tooltip": "O preenchimento do relatório técnico final já foi liberado"
    },
    on: {
      "click": function($event) {
        return _vm.goLiberarRelatorio()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "autorenew",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 20,
      "tooltip": "Desfazer Finalização (A ação volta a ficar ativa)",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando relatório\" pode ter sua finalização desfeita"
    },
    on: {
      "click": function($event) {
        return _vm.goDesfazerFinalizacao()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "pause_circle",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 18 && _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": (_vm.projeto.situacao.item === 18 || _vm.projeto.situacao.item === 3) ? 'Suspender' : 'Prorrogar suspensão',
      "disabled-tooltip": "Para ser suspensa, a ação de extensão deve estar na situação \"Ativo\" ou \"Inadimplente\". Para prorrogar a suspensão, a ação de extensão deve estar na situação \"Suspenso\""
    },
    on: {
      "click": function($event) {
        return _vm.goSuspenderAcaoExtensao()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "play_circle",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": "Reativar",
      "disabled-tooltip": "Para ser reativada, a ação de extensão deve estar na situação \"Suspenso\" ou \"Inadimplente\""
    },
    on: {
      "click": function($event) {
        return _vm.goReativarAcaoExtensao()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "folder",
      "color": "brown lighten-1",
      "disabled": _vm.projeto.situacao.item != 20 && _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": "Concluir",
      "disabled-tooltip": "Apenas uma ação na situação \"Suspenso\", \"Inadimplente\" ou \"Aguardando envio de relatório\" pode ser concluída"
    },
    on: {
      "click": function($event) {
        return _vm.goConcluirProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "cancel_presentation",
      "color": "red",
      "disabled": _vm.projeto.situacao.item != 18 && _vm.projeto.situacao.item != 20 && _vm.projeto.situacao.item != 4 && _vm.projeto.situacao.item != 3,
      "tooltip": "Cancelar",
      "disabled-tooltip": "Apenas uma ação na situação \"Ativo\", \"Inadimplente\", \"Suspenso\" ou \"Aguardando envio de relatório\" pode ser cancelada"
    },
    on: {
      "click": function($event) {
        return _vm.goCancelarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "cancel",
      "color": "black",
      "disabled": _vm.projeto.situacao.item != 16,
      "tooltip": "Inabilitar",
      "disabled-tooltip": "Apenas uma ação na situação \"Aguardando aprovação\" pode ser inabilitada"
    },
    on: {
      "click": function($event) {
        return _vm.goInabilitarProjeto()
      }
    }
  }), _vm._v(" "), _c('c-tooltip-btn', {
    attrs: {
      "icon": "mode",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 18 && _vm.projeto.situacao.item != 15,
      "tooltip": "Alterar classificação secundária",
      "disabled-tooltip": "A ação de extensão deve estar na situação \"Ativo\" ou \"Preenchimento incompleto\" para ter sua classificação secundária alterada"
    },
    on: {
      "click": function($event) {
        return _vm.goAlterarClassificacaoSecundaria()
      }
    }
  }), _vm._v(" "), (_vm.projeto.situacao.item != 21) ? _c('c-tooltip-btn', {
    attrs: {
      "icon": "delete",
      "color": "primary",
      "disabled": _vm.projeto.situacao.item != 15 && _vm.projeto.situacao.item != 16,
      "tooltip": "Excluir ação",
      "disabled-tooltip": "Apenas uma ação na situação \"Preenchimento incompleto\" ou \"Aguardando aprovação\" pode ser excluída"
    },
    on: {
      "click": function($event) {
        return _vm.botaoExcluirAcao()
      }
    }
  }) : _c('c-tooltip-btn', {
    attrs: {
      "icon": "restore_from_trash",
      "color": "primary",
      "tooltip": "Desfazer Exclusão"
    },
    on: {
      "click": function($event) {
        return _vm.goDesfazerExclusao()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba1a1cf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-barra-administrador.vue
// module id = 420
// module chunks = 0